import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAMES } from '@/constants';

export interface IMainLayoutState {
    isMenuOpen: boolean;
}

const initialState: IMainLayoutState = {
    isMenuOpen: true,
};

export const MainLayoutSlice = createSlice({
    name: SLICE_NAMES.MAIN_LAYOUT,
    initialState,
    reducers: {
        toggleMenu: (state, action: PayloadAction<boolean>) => {
            state.isMenuOpen = action.payload;
        },
    },
});

export const { toggleMenu } = MainLayoutSlice.actions;

export default MainLayoutSlice.reducer;
